export const viMessages = {
  nav: {
    home: "Trang chủ",
    about: "Giới thiệu",
    projects: "Dự án",
    blog: "Blog",
    cv: "Xuất CV",
    contact: "Liên hệ",
  },
  common: {
    language: "Ngôn ngữ",
    viewProjects: "Xem dự án",
    getInTouch: "Liên hệ",
    downloadCv: "Tải CV",
  },
  home: {
    heroGreetingDefault: "// Chào mừng đến với portfolio của mình",
    scroll: "CUỘN XUỐNG",
    stats: {
      openSourceRepos: "Repo open-source",
      monthsOfExperience: "Tháng kinh nghiệm",
      githubStars: "Lượt GitHub Stars",
      commits: "Lượt commit",
      projects: "Dự án",
      technologies: "Công nghệ",
      productionCommits: "Commit production",
    },
    experienceTitle: "Kinh nghiệm làm việc",
    experienceSubtitle: "Hành trình nghề nghiệp của mình cho tới hiện tại",
    techStackTitle: "Tech Stack",
    techStackSubtitle: "Công nghệ mình sử dụng hằng ngày",
    featuredProjectsTitle: "Dự án nổi bật",
    featuredProjectsSubtitle: "Một vài sản phẩm gần đây",
    featuredProjectsCta: "Xem tất cả dự án",
    ctaTitle: "Cùng hợp tác nhé",
    ctaSubtitle:
      "Nếu bạn đang tìm backend engineer hoặc cộng tác cho sản phẩm mới, mình luôn sẵn sàng trao đổi.",
    ctaButton: "Liên hệ",
    musicPlayer: {
      showPlaylist: "Danh sách bài hát",
      hidePlaylist: "Ẩn playlist",
      lyricsTitle: "Lời bài hát",
      noLyrics: "Chưa có lời. Thêm lời ở Admin → Nhạc.",
      expand: "Hiển thị lời & danh sách",
      collapse: "Thu gọn",
      shuffle: "Ngẫu nhiên",
      repeat: {
        off: "Không lặp",
        one: "Lặp 1 bài",
        all: "Lặp danh sách",
      },
      prev: "Bài trước",
      next: "Bài sau",
      play: "Phát",
      pause: "Tạm dừng",
      progress: "Tiến trình phát. Nhấp để nhảy.",
      volume: "Âm lượng",
    },
  },
  about: {
    title: "Về mình",
    skillsTitle: "Kỹ năng & Chuyên môn",
    experienceTitle: "Kinh nghiệm làm việc",
    educationTitle: "Học vấn",
    certificatesTitle: "Chứng chỉ",
    interestsTitle: "Sở thích",
    githubActivityTitle: "GitHub Activity",
    githubActivitySubtitle:
      "Ảnh chiếu chân thực về nhịp độ commit, repository nổi bật và những ngôn ngữ mình sử dụng thường xuyên trên GitHub.",
  },
  admin: {
    dashboard: "Dashboard",
    profile: "Hồ sơ",
    projects: "Dự án",
    experiences: "Kinh nghiệm",
    education: "Học vấn",
    skills: "Kỹ năng",
    certificates: "Chứng chỉ",
    music: "Nhạc",
    blog: "Blog",
    messages: "Tin nhắn",
    logout: "Đăng xuất",
    actions: {
      edit: "Sửa",
      delete: "Xóa",
      cancel: "Hủy",
    },
    dashboardPage: {
      title: "Dashboard",
      cards: {
        profileLabel: "Hồ sơ",
        profileSub: "Cài đặt",
        projectsLabel: "Dự án",
        projectsSub: "mục",
        experiencesLabel: "Kinh nghiệm",
        experiencesSub: "dòng",
        educationLabel: "Học vấn",
        educationSub: "dòng",
        skillsLabel: "Kỹ năng",
        skillsSub: "kỹ năng",
        certificatesLabel: "Chứng chỉ",
        certificatesSub: "chứng chỉ",
        musicLabel: "Nhạc",
        musicSub: "bài hát",
        blogLabel: "Bài viết",
        blogSub: "bài",
        messagesLabel: "Tin nhắn",
        messagesSub: "tin nhắn",
        messagesUnreadSuffix: "chưa đọc",
      },
    },
    messagesPage: {
      title: "Tin nhắn liên hệ",
      empty: "Chưa có tin nhắn nào.",
      markRead: "Đánh dấu đã đọc",
      markUnread: "Đánh dấu chưa đọc",
    },
    login: {
      title: "Đăng nhập Admin",
      email: "Email",
      password: "Mật khẩu",
      loading: "Đang đăng nhập...",
      submit: "Đăng nhập",
      backToHome: "← Quay lại trang chủ",
    },
    projectsPage: {
      title: "Quản lý Projects",
      formTitleAdd: "Thêm Project",
      formTitleEdit: "Sửa Project",
      deleteConfirm: "Xóa dự án này?",
      table: {
        title: "Title",
        tech: "Tech",
        featured: "Featured",
      },
      submitAdd: "Thêm",
      submitUpdate: "Cập nhật",
    },
    experiencesPage: {
      title: "Quản lý Experiences",
      formTitleAdd: "Thêm Experience",
      formTitleEdit: "Sửa Experience",
      deleteConfirm: "Xóa experience này?",
      badgeCurrent: "Hiện tại",
      badgePresent: "Present",
      submitAdd: "Thêm",
      submitUpdate: "Cập nhật",
    },
    educationPage: {
      title: "Quản lý Education",
      formTitleAdd: "Thêm Education",
      formTitleEdit: "Sửa Education",
      deleteConfirm: "Xóa education này?",
      submitAdd: "Thêm",
      submitUpdate: "Cập nhật",
    },
    skillsPage: {
      title: "Quản lý Skills",
      formTitleAdd: "Thêm Skill",
      formTitleEdit: "Sửa Skill",
      deleteConfirm: "Xóa skill này?",
      submitAdd: "Thêm",
      submitUpdate: "Cập nhật",
    },
    certificatesPage: {
      title: "Quản lý Certificates",
      formTitleAdd: "Thêm Certificate",
      formTitleEdit: "Sửa Certificate",
      deleteConfirm: "Xóa certificate này?",
      submitAdd: "Thêm",
      submitUpdate: "Cập nhật",
      previewAlt: "Xem trước",
    },
    musicPage: {
      title: "Quản lý Nhạc",
      formTitleAdd: "Thêm bài hát",
      formTitleEdit: "Sửa bài hát",
      deleteConfirm: "Xóa bài hát này?",
      submitAdd: "Thêm",
      submitUpdate: "Cập nhật",
      empty: "Chưa có bài hát nào.",
      titleLabel: "Tên bài",
      titlePlaceholder: "Tên bài hát",
      artistLabel: "Ca sĩ",
      artistPlaceholder: "Tên ca sĩ",
      coverLabel: "Ảnh bìa",
      audioLabel: "File nhạc (MP3/MP4)",
      audioHint: "Tự động lấy title, artist, ảnh bìa, độ dài từ metadata của file.",
      lyricsLabel: "Lời nhạc (LRC)",
      lyricsPlaceholder: "[00:12.50] Dòng đầu...\n[00:18.30] Dòng tiếp...",
      durationLabel: "Độ dài (giây)",
      sortLabel: "Thứ tự",
      audioSizeWarning: "File quá lớn (>15MB), có thể tải chậm. Tiếp tục upload?",
      table: {
        title: "Bài hát",
        artist: "Ca sĩ",
      },
    },
    blogPage: {
      title: "Quản lý Blog",
      formTitleAdd: "Thêm Bài viết",
      formTitleEdit: "Sửa Bài viết",
      deleteConfirm: "Xóa bài viết này?",
      statusPublished: "Đã xuất bản",
      statusDraft: "Bản nháp",
      submitAdd: "Thêm",
      submitUpdate: "Cập nhật",
    },
    profilePage: {
      title: "Profile Settings",
      saved: "✅ Profile saved!",
      syncing: "⏳ Syncing with GitHub...",
      syncSuccess: "✅ GitHub stats synced!",
      syncFailed: "❌ Sync failed.",
      errorPrefix: "❌ Error: ",
      alerts: {
        githubUrlMissing: "Please enter a GitHub URL first.",
        githubUrlInvalid: "Invalid GitHub URL.",
      },
      syncButton: "🔄 Sync GitHub Stats",
      submitSaving: "Saving...",
      submitDefault: "Save Profile",
    },
  },
} as const;

